import { assertNonEmptyString, assertUniqueValues } from './assertions'
import { GuideTourValidationError } from './errors'

export const validateGuideTourObserverSelectors = (
  selectors: string[] | undefined,
  fieldName: string
): void => {
  if (selectors === undefined) {
    return
  }

  if (!Array.isArray(selectors)) {
    throw new GuideTourValidationError(`${fieldName} must be an array`)
  }

  selectors.forEach((selector, index) => {
    assertNonEmptyString(selector, `${fieldName}[${index}]`)
  })

  assertUniqueValues(selectors, fieldName)
}
